import { createSelector } from 'reselect';
const selectAuthState = state => state.auth;
const selectContact = createSelector(selectAuthState, state => state.contact);
export const selectContactId = createSelector(selectContact, contact => contact === null || contact === void 0 ? void 0 : contact.contactVid);
export const selectIsAuthenticated = createSelector(selectAuthState, state => state.isLoggedIn);
export const selectIsAuthInitialized = createSelector(selectAuthState, state => state.initialized);
export const selectContactName = createSelector(selectContact, contact => {
  var _contact$firstname, _contact$lastname;
  const firstName = (_contact$firstname = contact === null || contact === void 0 ? void 0 : contact.firstname) !== null && _contact$firstname !== void 0 ? _contact$firstname : '';
  const lastName = (_contact$lastname = contact === null || contact === void 0 ? void 0 : contact.lastname) !== null && _contact$lastname !== void 0 ? _contact$lastname : '';
  const fullName = `${firstName} ${lastName}`.trim();
  return fullName || 'You';
});